import {
    PersonaOperationStateReason,
    PersonaOperationState,
    PersonaOperationStateType,
} from '../../shared';

export const getMoveOperationStateCombiner = (
    isMoveInProgress: boolean,
    areAllCurrentPersonasTypePersonaOrPDL: boolean,
    allCurrentPersonasWritable: boolean,
    isTooManyCurrentPersonasForMove: boolean
): PersonaOperationState => {
    if (isMoveInProgress) {
        return { type: PersonaOperationStateType.Disabled };
    }
    if (isTooManyCurrentPersonasForMove) {
        return {
            type: PersonaOperationStateType.Disabled,
            reason: PersonaOperationStateReason.tooManyItemsSelected,
        };
    }
    // Can only move writable personas
    return areAllCurrentPersonasTypePersonaOrPDL && allCurrentPersonasWritable
        ? allCurrentPersonasWritable
            ? { type: PersonaOperationStateType.Show }
            : {
                  type: PersonaOperationStateType.Disabled,
                  reason: PersonaOperationStateReason.readOnlyItem,
              }
        : { type: PersonaOperationStateType.Hide };
};
